import api from './api';
import authService from './authService';

/**
 * Service for SuperAdmin member management across all tenants
 */

// Get all members across all tenants with pagination, filtering, and search options
const getAllMembers = async (page = 1, limit = 10, search = '', filters = {}) => {
  try {
    console.log('SuperAdmin - getAllMembers called with:', { page, limit, search, filters });
    
    const params = { 
      page, 
      limit,
      search,
      ...(filters.status && { status: filters.status }),
      ...(filters.tenantId && { tenantId: filters.tenantId })
    };
    
    const token = authService.getToken();
    if (!token) {
      throw new Error('Authentication required');
    }

    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-Cross-Tenant': 'true'
    };

    const response = await api.get('/superadmin/members', { headers, params });
    return response.data;
  } catch (error) {
    console.error('SuperAdmin - getAllMembers error:', error);
    throw error;
  }
};

// Get a single member by ID
const getMember = async (memberId) => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error('Authentication required');
    }

    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-Cross-Tenant': 'true'
    };

    const response = await api.get(`/superadmin/members/${memberId}`, { headers });
    return response.data.data;
  } catch (error) {
    console.error('SuperAdmin - getMember error:', error);
    throw error;
  }
};

// Create a new member in any tenant
const createMember = async (memberData) => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error('Authentication required');
    }

    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-Cross-Tenant': 'true'
    };

    const response = await api.post('/superadmin/members', memberData, { headers });
    return response.data;
  } catch (error) {
    console.error('SuperAdmin - createMember error:', error);
    throw error;
  }
};

// Update a member by ID
const updateMember = async (memberId, memberData) => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error('Authentication required');
    }

    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-Cross-Tenant': 'true'
    };

    const response = await api.put(`/superadmin/members/${memberId}`, memberData, { headers });
    return response.data;
  } catch (error) {
    console.error('SuperAdmin - updateMember error:', error);
    throw error;
  }
};

// Delete a member by ID
const deleteMember = async (memberId) => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error('Authentication required');
    }

    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-Cross-Tenant': 'true'
    };

    const response = await api.delete(`/superadmin/members/${memberId}`, { headers });
    return response.data;
  } catch (error) {
    console.error('SuperAdmin - deleteMember error:', error);
    throw error;
  }
};

// Transfer a member to a different tenant
const transferMember = async (memberId, newTenantId) => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error('Authentication required');
    }

    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-Cross-Tenant': 'true'
    };

    const response = await api.put(
      `/superadmin/members/${memberId}/transfer`,
      { newTenantId },
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error('SuperAdmin - transferMember error:', error);
    throw error;
  }
};

// Get member analytics across all tenants
const getMemberAnalytics = async () => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error('Authentication required');
    }

    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-Cross-Tenant': 'true'
    };

    const response = await api.get('/superadmin/analytics/members', { headers });
    return response.data.data;
  } catch (error) {
    console.error('SuperAdmin - getMemberAnalytics error:', error);
    throw error;
  }
};

// Get all tenants for dropdown menus
const getAllTenants = async () => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error('Authentication required');
    }

    const headers = {
      'Authorization': `Bearer ${token}`,
      'X-Cross-Tenant': 'true'
    };

    const response = await api.get('/superadmin/tenants', { headers });
    return response.data.data;
  } catch (error) {
    console.error('SuperAdmin - getAllTenants error:', error);
    throw error;
  }
};

const superAdminMemberService = {
  getAllMembers,
  getMember,
  createMember,
  updateMember,
  deleteMember,
  transferMember,
  getMemberAnalytics,
  getAllTenants
};

export default superAdminMemberService;